import React, { useEffect, useState } from "react";
import Image from "next/image";
import axios from "axios";
import Link from "next/link";
import { API_URL, ASSETS_URL } from "@/Constant";

const ServiceEleven = ({ isTitle, countrydream }) => {
  const buttonClass = {
    width: "100%",
    textAlign: "center",
    fontFamily: '"Noto Sans", sans-serif',
    fontWeight: 600,
    fontSize: "16px",
    color: "#000000",
    borderRadius: "56px",
    border: "1px solid #000000",
    padding: "13px 24px",
    cursor: "pointer",
  };

  return (
    <div className="container">
      {isTitle === undefined && (
        <div className="row mb--60">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h2 className="title">Countries</h2>
            </div>
          </div>
        </div>
      )}

      <div className="row mt_dec--30" style={{
        display:"flex",
        justifyContent:"center",
        alignItems:"center",
        flexWrap:"wrap"
      }}>
        {countrydream.map((country, index) => (
          <div
            className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mt--30"
            key={country.id}
          >
            <div className="rbt-flipbox variation-2">
              <div
                className={`rbt-flipbox-wrap rbt-service rbt-service-1 card-bg-${
                  (index % 4) + 1
                }`}
              >
                {/* Front Side */}
                <div
                  className="rbt-flipbox-front rbt-flipbox-face inner"
                  style={{
                    padding: "0px",
                    marginBottom: "0px",
                  }}
                >
                  <div
                    className="front-thumb w-100"
                    style={{
                      position: "relative",
                      width: "440px",
                      height: "400px",
                    }}
                  >
                    <img
                      src={country.bannermobile ? `${ASSETS_URL}/${country.bannermobile}`:`${ASSETS_URL}/${country.banner}`}
                      width={440}
                      height={400}
                      alt={country.countryName}
                      style={{
                        marginBottom: "0px",
                        position:"absolute",
                        minHeight: "400px",
                        minWidth: "440px",
                        display: "block",
                      }}
                    />
                    <div 
                    style={{
                      height:"100%",
                      width:"100%",
                      position:"absolute",
                      background:"black",
                      opacity:"0.4"
                    }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "#FFFFFF",
                        textAlign: "center",
                        fontSize: "24px",
                        fontWeight: 700,
                      }}
                    >
                      {country.countryName}
                    </div>
                  </div>
                </div>

                {/* Back Side */}
                <div className="rbt-flipbox-back rbt-flipbox-face inner">
                  <div className="flip-back-top">
                    <h5 className="title">{country.countryName}</h5>
                    <p
                      style={{
                        color: "#868686",
                        maxHeight: "251px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {country.discription}
                    </p>
                  </div>
                  <Link
                    href={`/${country.slug}`}
                    style={{
                      width: "-webkit-fill-available",
                    }}
                  >
                    <div
                      style={buttonClass}
                      className="mt--10 hovered_bg_colour "
                    >
                      Discover
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceEleven;
